import { Button, Typography } from '@mgmresorts/wcl-lab';
import { navigate } from 'hookrouter';
import React, { useCallback } from 'react';

import { Container } from '../../components/ui/Container';
import { Logo } from '../../components/ui/Logo';
import { PageLayout } from '../../components/ui/PageLayout';

export function NotFoundPage() {
  const goBack = useCallback(() => navigate('/'), []);
  return (
    <PageLayout
      title='Page not found'
      testId='not-found'
      description='There was an error with the page you are trying to access'
    >
      <Container height='auto'>
        <Logo className='identity__page-logo' />
        <Typography variant='h2' className='identity__page-heading'>
          Page not found
        </Typography>
        <Typography variant='body' className='identity__page-heading'>
          There was an error with the page you are trying to access
        </Typography>
        <Button
          onClick={goBack}
          onKeyPress={e => {
            e.preventDefault();
            if (e.key === 'Enter') {
              goBack();
            }
          }}
          sticky
          className='form-buttom identity__form-submit'
          testId='go-back'
          type='submit'
        >
          Go back
        </Button>
      </Container>
    </PageLayout>
  );
}
